import type { IconName } from '@zen/Styleguide';

export const getToggleIcon = (isExpanded: boolean): IconName =>
  isExpanded ? 'zicon-chevron-down-small' : 'zicon-chevron-right-small';

export const getToggleLabel = (isExpanded: boolean): string => (isExpanded ? 'Collapse' : 'Expand');
